import { Dispatch } from "redux";
import { CategoryList } from "../../models/CategoriesModel";
import { getAll } from "../../services/categories";
import { UPDATE_API_FETCHING } from "../api_details/types";
import { RETRIEVE_CATEGORIES } from "./types";

export const retrieveCategories =
    () =>
    async (dispatch: Dispatch): Promise<CategoryList> => {
        try {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: true },
            });

            const response = await getAll();

            dispatch({
                type: RETRIEVE_CATEGORIES,
                payload: response.data,
            });

            return Promise.resolve(response.data);
        } catch (err) {
            return Promise.reject(err);
        } finally {
            dispatch({
                type: UPDATE_API_FETCHING,
                payload: { status: false },
            });
        }
    };
